import React from 'react';
import ReactModal from 'react-modal';

import Colors from '../../config/Colors';

import { Footer, modalContentConfig, Header, Title, CloseButtonIcon, ModalContent, Body } from './styles';
import ButtonLoading from '../buttonLoading';
import { Close } from '@mui/icons-material';

const ModalComponent = ({
    width = '30%',
    title,
    cancelText = 'Cancelar',
    saveText = 'Ok',
    children,
    onSave,
    onClose = () => {},
    enabledClose = false,
    isSaveButtonLoading = false,
    disabledSave = false,
    removeButtons = false,
    enableTopClose = true
}) => {
    const closeModal = () => {
        if (!isSaveButtonLoading) {
            onClose();
        }
    };

    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={true}
            onRequestClose={closeModal}
            contentLabel={title}
            parentSelector={() => {
                return document.querySelector('#ReactModalPortal');
            }}
            style={{
                overlay: {
                    backgroundColor: Colors.darkerTransparent
                },
                content: { ...modalContentConfig, width }
            }}
        >
            <ModalContent>
                <Header>
                    <Title>{title}</Title>
                    { enableTopClose && <CloseButtonIcon onClick={closeModal}>
                        <Close
                            sx={{
                                pointerEvents: isSaveButtonLoading ? 'none' : 'auto',
                                fontSize: 20,
                                color: Colors.white,
                             }}                            
                        />
                    </CloseButtonIcon>}
                </Header>

                {children && (
                    <Body style={{ opacity: isSaveButtonLoading ? 0.6 : 1 }}>
                        {children}
                    </Body>
                )}

                {!removeButtons && (
                    <Footer>
                        {enabledClose && (
                            <ButtonLoading
                                style={{
                                    paddingVertical: 4,
                                    paddingHorizontal: 16,
                                    marginTop: 0,
                                    backgroundColor: 'gray',
                                    marginRight: 15
                                }}
                                onPress={onClose}
                                label={cancelText}
                                disabled={isSaveButtonLoading}
                            />
                        )}

                        <ButtonLoading
                            style={{
                                paddingVertical: 4,
                                paddingHorizontal: 16,
                                marginTop: 0
                            }}
                            onPress={onSave}
                            label={saveText}
                            isLoading={isSaveButtonLoading}
                            disabled={disabledSave}
                        />
                    </Footer>
                )}
            </ModalContent>
        </ReactModal>
    );
};

export default ModalComponent;
